import { AsyncStatusEnum, SearchCategories } from './common';
import { ResultCardState } from './research';
import {
  TopicAndStatsAPIResponse,
  BookmarkServerResponse,
  SaveBookmarkSuccessAPIResponse,
} from './api';

/**
 * Tabs for bookmarked card
 */
export enum BookmarkCardTabEnum {
  OVERVIEW = 'overview',
  // HIGHLIGHTS = 'highlights',
  TOPICS = 'topics',
  // STATS = 'stats', @TODO: add stats tab
}

/**
 * Notebook tabs
 */
export enum NotebookSubTabEnum {
  BOOKMARK = 'bookmarks',
  IDEA = 'ideas',
}
/**
 * The Sequence of the notebook and bookmark card tab order
 */
export const NOTEBOOK_SUB_TAB_SEQ = [
  // NotebookSubTabEnum.BOOKMARK,
  NotebookSubTabEnum.IDEA,
];

export const BOOKMARK_CARD_TAB_SEQ = [
  BookmarkCardTabEnum.OVERVIEW,
  // BookmarkCardTabEnum.HIGHLIGHTS,
  BookmarkCardTabEnum.TOPICS,
  // BookmarkCardTabEnum.STATS, @TODO: enable this when stats-ui is ready
];

/**
 * Bookmark state is very similar to result card state except the inner tabs
 * and id. id is mongoDB id and resourceId is id from search API when resource
 * was bookmarked.
 */
export interface BookmarkCardState
  extends Omit<ResultCardState, 'activeTab' | 'vote' | 'provider' | 'position'> {
  activeTab: BookmarkCardTabEnum;
}
/**
 * Bookmark state is map of mongoId to bookmark card state
 */
export interface BookmarkState {
  [id: string]: BookmarkCardState;
}

/**
 * Marks all possible actions under bookmark
 */
export enum BookmarkActionNameEnum {
  SaveBookmarkSuccess = 'rshr/user/clicked_bookmark_button',
  DeleteBookmarkSuccess = 'rshr/user/remove_bookmark_action_type',
  SetLoadingStatus = 'rshr/system/bookmark/set_loading',
  RestoreAllBookmarkData = 'rshr/system/bookmark/restore_all_bookmarks',
  PullingSource = 'rshr/user/bookmark/pulling_source',
  PulledSource = 'rshr/user/bookmark/pulled_source',
  PulledSourceError = 'rshr/user/bookmark/pulled_source_error',
  ChangeTabInsideCard = 'rshr/user/bookmark/change_tab_inside_card',
}

/**
 * When project is restored from API we get bookmarks[] which is array of ServerBookmarkResponse
 * which is then converted to BookmarkState as this action.
 */
export interface RestoreAllBookmarkDataAction {
  type: BookmarkActionNameEnum.RestoreAllBookmarkData;
  payload: BookmarkServerResponse[];
}

/**
 * When user clicks bookmark and api succeeds, this action is dispatched
 * to update the state of the bookmark state by entering the new bookmark
 * to the state.
 */
export interface SaveBookmarkSuccessAction {
  type: BookmarkActionNameEnum.SaveBookmarkSuccess;
  payload: SaveBookmarkSuccessAPIResponse;
}
/**
 * When user clicks delete bookmark and api succeeds, this action is dispatched
 */
export interface DeleteBookmarkSuccessAction {
  type: BookmarkActionNameEnum.DeleteBookmarkSuccess;
  payload: {
    id: string;
  };
}
/**
 * set loading status for a bookmark
 */
export interface SetBookmarkLoadingStatusAction {
  type: BookmarkActionNameEnum.SetLoadingStatus;
  payload: {
    id: string;
    status: AsyncStatusEnum;
  };
}

/**
 * When bookmark component is mounted the data must be loaded from the server
 */
export interface PullingSourceAction {
  type: BookmarkActionNameEnum.PullingSource;
  payload: {
    id: string;
  };
}

export interface PulledSourceSuccessAction {
  type: BookmarkActionNameEnum.PulledSource;
  payload: {
    id: string;
  } & TopicAndStatsAPIResponse;
}

export interface PulledSourceErrorAction {
  type: BookmarkActionNameEnum.PulledSourceError;
  payload: {
    id: string;
  };
}

/**
 * After data for tab is pulled, user can change the tab inside the card
 */
export interface ChangeTabInsideCardAction {
  type: BookmarkActionNameEnum.ChangeTabInsideCard;
  payload: {
    tab: BookmarkCardTabEnum;
    id: string;
  };
}

export type BookmarkActions =
  | SaveBookmarkSuccessAction
  | DeleteBookmarkSuccessAction
  | SetBookmarkLoadingStatusAction
  | RestoreAllBookmarkDataAction
  | PullingSourceAction
  | PulledSourceSuccessAction
  | PulledSourceErrorAction
  | ChangeTabInsideCardAction;
